import { render, staticRenderFns } from "./LegalSubmitButton.vue?vue&type=template&id=28264fee&"
import script from "./LegalSubmitButton.vue?vue&type=script&lang=js&"
export * from "./LegalSubmitButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports